module.exports = __webpack_public_path__ + "static/media/My ownership white.44a0eaa1.svg";